import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import LocalPostOfficeIcon from '@mui/icons-material/LocalPostOffice';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { CssTextField } from '../layout/elements';
import { useAuth } from '../../hooks/useAuth';
import { Avatar, Box, Container, Divider, Grid, Paper, Tab, Tabs, Typography, styled } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { ChangePass, updateProfile, uploadAvatar } from '../../services/user-services';
import config from "../../config-site";
import { NotificationManager } from 'react-notifications';

const address_api = config[0].address;

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));
  
export default function AccountPublic() {
    const { authData } = useAuth()

    const [ image, setImage ] = useState('')
    const [ imageSelect, setImageSelect ] = useState('')
    const [password, setPassword ] = useState('')
    const [password2, setPassword2 ] = useState('')
    const [oldPassword, setOldPassword ] = useState('')

    const [value, setValue] = useState(0)
    // const [username, setUserName ] = useState('')
    const [last_name, setLastName ] = useState('')
    const [email, setEmail ] = useState('')
    const [mobileNumber, setMobileNumber ] = useState('')
    const [address, setAddress ] = useState('')

    const [loading, setLoding] = useState(false)
    const [error, setError ] = useState(false)
    const [msgError, setMsgError ] = useState('')

    const passMatch = () => {
        return password === password2
    }
    
    const onSelectFile = async e => {
        if (!e.target.files || e.target.files.length === 0) {
            setImageSelect(undefined)
            return
        }
        e.preventDefault()
        setLoding(true)
        // setImage(e.target.files[0])
        // I've kept this example simple by using the first image instead of multiple
        setImageSelect(e.target.files[0])
        const uploaddata = new FormData()
        uploaddata.append('image', e.target.files[0], e.target.files[0].name)
        // const loadData = authData
        await uploadAvatar(authData.user.id, authData.token, uploaddata)
        setLoding(false)
        // console.log(authData)
        setImage(URL.createObjectURL(e.target.files[0]))
    }
    
    const handleChange = (event, newValue) => {
        // console.log(newValue);
        setValue(newValue)
    };

    useEffect(()=>{
        // console.log(authData);
        setImage(`${address_api}${authData?.user?.profile?.image}`)
        setLastName(authData?.user?.last_name)
        setAddress(authData?.user?.profile?.address_user)
        setMobileNumber(authData?.user?.profile?.phone_user)
        setEmail(authData?.user?.email)
    }, [])

    
    const handelRegisterSubmit = async e => {
        e.preventDefault()
        if (passMatch) {
            const regData = await updateProfile(authData?.user.id, authData?.token, 
                    {last_name, email,  
                    profile:{phone_user: mobileNumber, address_user: address}})
            if (regData) {
                // console.log(regData)
                NotificationManager.success('پروفایل با موفقیت تغییر کرد')
                // const data = await auth({username, password});
                // setAuth(data);
                // window.location.href = window.location.pathname
            }else{
                setError(true);
                setMsgError(regData.message)
                NotificationManager.error('خطا در ارتباط', 'کلیک کنید!', 5000, () => {
                    alert('callback');
                });
            }
        }
    }

    const setNewPassword = async e => {
          e.preventDefault();
          if (passMatch()) {
            // NotificationManager.success('رمز با موفقیت تغییر کرد');
            // const getPassData = async() =>{
            //     await ChangePass(
            //         {'old_password':oldPassword, 'new_password':password},
            //         authData.user.id,
            //         authData.token)
            //     .then(data => {
            //         setMsgError(data);
            //         setLoding(false);
            //         setError(false);
            //     }).catch( e => {
            //         setError(true);
            //         setLoding(false);
            //     })
            // }
            // getPassData();  
            const passData = await ChangePass(
                {'old_password':oldPassword, 'new_password':password},
                authData.user.id,
                authData.token)
                
            //   console.log('passData', passData);
              if (passData) {
                  NotificationManager.success('رمز با موفقیت تغییر کرد')
              }else{
                setError(true)
                // setMsgError(passData.message);
              }
          }else{
                setError(true)
                setMsgError('رمز و تکرار آن متفاوت می باشند')
                NotificationManager.error('رمز و تکرار اشتباه است', 'کلیک کنید!' , 5000, () => {
                    alert('callback')
                });
          }
    }

  return (
    
    <Box elevation={3} sx={{  
        bgcolor: 'background.paper', 
        minHeight: 1000,
        margin: '0.5rem 1rem 0.5rem 0.5rem' }}
        textAlign={'center'}
        >
        <br />
        <br />
        <div style={{textAlign: 'center'}}>
            
            <Grid container alignItems='flex-end'>
                <Grid item xs={12} >
                    <div>
                        <input
                            accept="image/*"
                            style={{ display: 'none' }}
                            id="raised-button-file"
                            multiple
                            type="file"
                            onChange={onSelectFile}
                            />
                        <label htmlFor="raised-button-file">
                            <Button variant="raised" component="span" >
                                <div>
                                    <Avatar alt={authData?.user?.username} 
                                        src={image} sx={{ width: 120, height: 120 }} />
                                </div>
                            </Button>
                        </label> 
                    </div>
                </Grid>
                
            </Grid>
            <br/><br/>
            <Grid container alignItems='flex-end'>
                <Grid item xs={12}>
                    <Typography
                        component="span"
                        variant="h3"
                        color="primary"
                        fontFamily={'iran1'}
                        textAlign={'center'}
                        >
                        به پنل حساب خوش آمدید
                    </Typography>            
                </Grid>
            </Grid>

        </div>
        <br />
        <br />
        
        <Paper elevation={3} sx={{ bgcolor: 'background.paper'}}>
          <Tabs value={value} onChange={handleChange} centered >
              <Tab 
                label={(
                    <Typography 
                        variant="h5"
                        fontFamily='vaziri' 
                        component="body"
                    >
                        {"اطلاعات شخصی"}
                    </Typography>
                    )} 
                />
              <Tab 
                label={(
                    <Typography 
                        variant="h5"
                        fontFamily='vaziri' 
                        component="body"
                        >
                        {"امنیت"}
                    </Typography>
                    )} 
                />
            </Tabs>
            <br />
            
            {authData && value===1 &&
                <Container  maxWidth="sm">
                    <Item>
                        <div style={{textAlign: 'left'}}>
                        <form  onSubmit={setNewPassword}>
                            <Grid container spacing={2} alignItems='flex-end' sx={{ my: 2}}>
                                <Grid item>
                                    <VpnKeyIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                </Grid>
                                <Grid item xs={10}>
                                    <CssTextField 
                                        id="oldPass_id" 
                                        label={(
                                            <Typography 
                                                fontFamily='vaziri_light' 
                                                component="div"
                                                variant="h6"
                                                >
                                                {"رمزعبورقبلی:"}
                                            </Typography>
                                        )}
                                        fullWidth
                                        variant="standard" type='password' 
                                        onChange={ e => setOldPassword( e.target.value )} 
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} alignItems='flex-end' sx={{ my: 2}}>
                                <Grid item>
                                    <VpnKeyIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                </Grid>
                                <Grid item xs={10}>
                                    <CssTextField id="newPass_id"
                                        label={(
                                            <Typography 
                                                fontFamily='vaziri_light' 
                                                component="div"
                                                variant="h6"
                                                >
                                                {"رمزعبورجدید:"}
                                            </Typography>
                                        )}
                                        fullWidth
                                        variant="standard" type='password' 
                                        onChange={ e => setPassword( e.target.value )} 
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} alignItems='flex-end' sx={{ my: 2}}>
                                <Grid item>
                                    <VpnKeyIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                </Grid>
                                <Grid item xs={10}>
                                    <CssTextField id="newPass_id2"
                                        label={(
                                            <Typography 
                                                fontFamily='vaziri_light' 
                                                component="div"
                                                variant="h6"
                                                >
                                                {"تکراررمزعبورجدید"}
                                            </Typography>
                                        )}
                                        fullWidth
                                        variant="standard" type='password' 
                                        onChange={ e => setPassword2( e.target.value )} 
                                    />
                                </Grid>
                            </Grid>
                            
                            <Button type='submit' variant="contained" color="primary" sx={{ my: 2}}>
                                <Typography 
                                    fontFamily="Segoe UI"
                                    component="body"
                                    variant="h6"
                                    color={"secondry"}
                                    >
                                    ثبت
                                </Typography>
                            </Button>

                        </form >
                        {error &&
                            <Typography 
                                fontFamily="Segoe UI"
                                component="body"
                                variant="h6"
                                color={"secondry"}
                                >
                                خطا در ارتباط {msgError}
                            </Typography>
                        }
                        </div>
                    </Item>
                </Container>
                }
                {authData && value===0 &&
                  <Container maxWidth="sm" >
                    <Item>
                      <div style={{textAlign: 'center'}}>
                        
                        <form onSubmit={handelRegisterSubmit}>
                            <Divider />
                            <Grid container spacing={2} alignItems='flex-end' sx={{ my: 2}}>
                                <Grid item>
                                    <AccountCircle sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                </Grid>
                                <Grid item  xs={10}>
                                    <CssTextField id="input-famili" 
                                        label={(
                                            <Typography 
                                                fontFamily='vaziri_light' 
                                                component="h6"
                                                variant="h5"
                                                >
                                                {"نام و نام خانوادگی:"}
                                            </Typography>
                                        )}
                                        
                                        variant="standard" value={last_name}
                                        fullWidth
                                        onChange={ e => setLastName( e.target.value )} />
                                </Grid>
                            </Grid>
                            
                            
                            <Grid container spacing={2} alignItems='flex-end' sx={{ my: 2}}>
                                <Grid item>
                                    <LocalPostOfficeIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                </Grid>
                                <Grid item xs={10}>
                                    <CssTextField id="input-email" 
                                        label={(
                                            <Typography 
                                                fontFamily='vaziri_light' 
                                                component="h6"
                                                variant="h5"
                                                >
                                                {"ایمیل:"}
                                            </Typography>
                                        )}
                                        type='email'
                                        fullWidth
                                        variant="standard" value={email}
                                        onChange={ e => setEmail( e.target.value )} />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} alignItems='flex-end' sx={{ my: 2}}>
                                <Grid item>
                                    <LocalPostOfficeIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                </Grid>
                                <Grid item xs={10}>
                                    <CssTextField id="input-tel-number" 
                                        label={(
                                            <Typography 
                                                fontFamily='vaziri_light' 
                                                component="h6"
                                                variant="h5"
                                                >
                                                {"تلفن تماس:"}
                                            </Typography>
                                        )}
                                        fullWidth
                                        variant="standard" value={mobileNumber}
                                        onChange={ e => setMobileNumber( e.target.value )} />
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} alignItems='flex-end' sx={{ my: 2}}>
                                <Grid item sx={{marginTop: '1fr', marginBottom: 'auto',}}>
                                    <LocalPostOfficeIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                </Grid>
                                <Grid item xs={10}>
                                    <CssTextField id="input-address" 
                                        label={(
                                            <Typography
                                                fontFamily='vaziri_light' 
                                                component="div"
                                                variant="h5"
                                                >
                                                {"آدرس:"}
                                            </Typography>
                                        )}
                                        multiline
                                        fullWidth
                                        rows={4} 
                                        variant="standard" value={address}
                                        onChange={ e => setAddress( e.target.value )} />
                                </Grid>
                            </Grid>
                            <Divider />

                            <Grid container spacing={2} sx={{ mt: 2}}>
                                <Grid item xs={12} sm={10}>
                                    <Button variant="contained" 
                                        color="primary" type="submit"
                                        sx={{
                                            paddingLeft: 5, 
                                            paddingRight: 5
                                        }}
                                        disabled={!last_name || !email || !mobileNumber}
                                        >
                                        <Typography 
                                            fontFamily="vaziri"
                                            component="body"
                                            variant="h6"
                                            color={"secondry"}
                                            >
                                            {"ثبت"}
                                        </Typography>
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                        {error &&
                            <Typography 
                                fontFamily="Segoe UI"
                                component="body"
                                variant="h6"
                                color={"secondry"}
                                >
                                خطا در ارتباط {msgError}
                            </Typography>
                        }
                      </div>
                    </Item>
                  </Container>
                }
          </Paper>
      </Box>
    
  );
}
  
